import { Checkbox, Css } from "@homebound/beam";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";

type DimensionTypeCheckboxesProps = {
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
  selectedTypeIds: string[];
  onChange: (typeIds: string[]) => void;
};

export function DimensionTypeCheckboxes(props: DimensionTypeCheckboxesProps) {
  const { dimensionResults, selectedTypeIds, onChange } = props;
  function toggle(typeId: string, selected: boolean) {
    onChange(selected ? [...selectedTypeIds, typeId] : selectedTypeIds.filter((id) => id !== typeId));
  }
  return (
    <div css={Css.df.fdc.gap2.mb1.$}>
      {dimensionResults.map((r) => (
        <Checkbox
          key={r.type.id}
          label={r.type.name}
          selected={selectedTypeIds.includes(r.type.id)}
          onChange={(next) => toggle(r.type.id, next)}
        />
      ))}
    </div>
  );
}
